"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authenticating = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const react_1 = tslib_1.__importDefault(require("react"));
const Authenticating = () => (react_1.default.createElement(core_1.Container, { maxWidth: "sm" },
    react_1.default.createElement(core_1.Typography, { component: "h1", gutterBottom: true }, "Authentication is in progress"),
    react_1.default.createElement(core_1.Typography, { variant: "body1" }, "You will be redirected to the login page")));
exports.Authenticating = Authenticating;
//# sourceMappingURL=authenticating.js.map